/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import WarningRoundedIcon from '@mui/icons-material/WarningRounded'
import DefaultProximityLogo from '../../components/1elements/Icons/svg/proximityLogo.svg'
import sixfactorLogo from '../../components/1elements/Icons/svg/sixfactorLogoMono.svg'
import { Text } from '../../components/1elements'
import signInBackground from '../../assets/signInBackground.jpg'
import {
  getSignInLogo,
  getSignInText,
  getSigninBg
} from '../../common/dynamicCustomizationService'
import { useLocation, useNavigate } from 'react-router-dom'
import ApiService from '../../common/ApiCalls'
import { populatePermissions } from './reducers/LocalStoragePermissionsHandler'
import { signInStorageHandler } from './reducers/storageHandler'
import { establishOrRefreshSession } from '../../common/sessionGate'
import './AuthenticationLayout.scss'

const proximityLogo = getSignInLogo() ?? DefaultProximityLogo
const welcomeText = getSignInText() ?? 'Mapping Business Intelligence'
const signinBg = getSigninBg()

let styledBgImg = ''

if (!signinBg) styledBgImg = signInBackground

const GuestConfirm = () => {
  const navigate = useNavigate()
  const [error, setError] = React.useState(false)

  const query = new URLSearchParams(useLocation().search)
  const token = query.get('token')

  const redirectToLogin = () => {
    navigate('/login')
  }

  const errorState = (message = 'Link is invalid or has expired') => {
    setError({ title: 'Could not log you in', message })
  }

  React.useEffect(() => {
    if (!token) {
      setError({
        title: 'Could not complete request',
        message: 'Your link is invalid.'
      })
    } else {
      const api = ApiService()
      api.confirmGuestToken(token)
        .then((resp) => {
          if (resp?.status === 200) {
            window.localStorage.setItem('token', resp.data.data.access_token)
            window.localStorage.setItem('username', 'Guest')
            establishOrRefreshSession(true)
            api.loginInfo()
              .then(resp => {
                if (resp?.status === 200) {
                  populatePermissions(resp)
                  signInStorageHandler(resp, 'guest')
                  navigate('/')
                } else {
                  errorState('Could not verify your permissions.')
                }
              })
              .catch((err) => {
                console.error(err)
                errorState('Could not verify your permissions.')
              })

          } else {
            errorState()
          }
        })
        .catch(() => {
          errorState()
        })
    }
  }, [token, navigate])

  return (
    <div
      className='authentication-root'
      style={{ backgroundImage: `url(${styledBgImg})` }}
    >
      <div className='authentication-login-container'>
        <div className='authentication-logo'>
          <img src={proximityLogo} alt='logo' />
          <div
            id='localCheat'
            type='oneLiner'
            className='authentication-tagline'
            dangerouslySetInnerHTML={{ __html: welcomeText }}
          />
        </div>

        {!error && <>
          <Text>
            <p><strong>Logging you in</strong></p>
          </Text>

          <CircularProgress />
        </>}

        {error && <>
          <div className='authentication-alert'>
            <div className='authentication-warning-row'>
              <WarningRoundedIcon className='authentication-warning-icon' />
              <Text type='warnMessage'>
                <strong>{ error.title }</strong>
              </Text>
            </div>
            <Text type='warnMessage'>{ error.message }</Text>
          </div>
        </>}

        <div className='authentication-spacer' />

        <Text type="terms">
          <a
            className='authentication-link'
            onClick={redirectToLogin}
            rel='noopener noreferrer'
            style={{ cursor: 'pointer' }}
          >
            Return to account login
          </a>
        </Text>

        <div className='authentication-spacer' />

        <div className='authentication-footer'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://sixfactor.com/'
          >
            <img
              src={sixfactorLogo}
              alt='sixfactor'
              width='60px'
              className='authentication-sixfactor-logo'
            />
          </a>
          <Text type='terms'>
            <a
              className='authentication-link'
              target='_blank'
              rel='noopener noreferrer'
              href='https://sixfactor.com/contact/'
            >
              Customer Support
            </a>
          </Text>
        </div>
      </div>
    </div>
  )
}

export default GuestConfirm
